import styled from '@emotion/styled';
import { css } from '@emotion/react';
import tokens from '@vaa-component-lib/shared.design-tokens/json/variables.json';
import { DATEPICKER_STYLES } from '../date-picker/date-picker.styles';
import { BreakPointToken } from '../../hooks/useMediaQuery';

import { NoGapSupport } from '../../lib/utils/mixins';

export const DatePicker = styled.div`
	color: black;
	max-width: ${DATEPICKER_STYLES.WIDTH}px;

	@media (max-width: ${BreakPointToken.MdMax}px) {
		margin-right: auto;
		margin-left: auto;
	}

	&:not(:first-of-type) {
		margin-top: ${tokens.spacing.size_16px.height}px;

		@media (min-width: ${BreakPointToken.MdMin}px) {
			margin-top: 0;

			${NoGapSupport(
				() => css`
					margin-left: ${DATEPICKER_STYLES.GUTTER}px;
				`
			)}
		}
	}
`;

interface DateGridProps {
	offset: string;
}

export const DateGrid = styled.div<DateGridProps>`
	display: grid;
	grid-template-columns: repeat(7, 1fr);

	button {
		width: 40px;
		height: 40px;

		&:first-of-type {
			grid-column: ${({ offset }) => offset};
		}
	}
`;

export const DaysHeading = styled.div`
	color: var(--token-color-colour-text-secondary);

	> div {
		display: grid;
		grid-template-columns: repeat(7, 1fr);
		text-align: center;
		margin-bottom: ${tokens.spacing.size_16px.height}px;
	}
`;

export const MonthHeading = styled.div`
	text-align: center;
	margin-bottom: ${tokens.spacing.size_16px.height}px;
`;

export const Day = styled.button`
	text-align: center;
	border: none;
	background: transparent;
	cursor: pointer;
`;
